import { useEffect, useState } from 'react';
import { fetchPlaces } from '../../../../modules/api';

const usePlaces = (id) => {
  const [waiting, setWaiting] = useState(true);

  const [places, setPlaces] = useState(null);

  const [currentPlace, setCurrentPlace] = useState(null);

  const [start, setStart] = useState(true);

  const [setupMap, setSetupMap] = useState(0);

  useEffect(() => {
    if (id && !places) {
      (async () => {
        const feed = await getPlacesFeed(id);

        if (feed) {
          setPlaces(feed);
          setCurrentPlace(feed.places[0]);
          setWaiting(false);
        }
      })();
    }
  }, [id]);

  // Hack to force ref to update
  useEffect(() => {
    setStart(start + 1);
  }, [waiting]);

  const getPlacesFeed = async (id = '') => {
    try {
      return await fetchPlaces(id);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Can not get places feed', error);
    }
  };

  return {
    waiting,
    places,
    currentPlace,
    setCurrentPlace,
    start,
    setupMap,
    setSetupMap,
  };
};

export default usePlaces;
